export const manifest = {
  screens: {
    scr_hdu50e: { name: "Home", route: "/" },
  },
}
